import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Lock } from "lucide-react";

export function Section({ icon: Icon, title, subtitle, children, tint = "indigo" }) {
  const tints = { indigo: "bg-indigo-50 text-indigo-600", emerald: "bg-emerald-50 text-emerald-600" };
  return (
    <section className="mt-12 fade-up print-avoid-break">
      <div className="flex items-start gap-3 mb-5">
        <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${tints[tint]}`}><Icon className="h-5 w-5" /></div>
        <div>
          <h2 className="font-display font-black text-3xl tracking-tight">{title}</h2>
          {subtitle && <p className="text-zinc-500 text-sm mt-1 max-w-2xl">{subtitle}</p>}
        </div>
      </div>
      {children}
    </section>
  );
}

export function LockedSection({ locked, icon, title, children }) {
  return (
    <Section icon={icon} title={<span className="inline-flex items-center gap-2">{title} {locked && <Badge className="bg-indigo-600">Pro</Badge>}</span>}>
      <div className="relative">
        {children}
        {locked && (
          <div data-testid="section-lock-overlay" className="absolute inset-0 backdrop-blur-md bg-white/60 rounded-2xl flex items-center justify-center">
            <div className="bg-white border border-zinc-200 rounded-2xl px-6 py-5 shadow-xl text-center max-w-md">
              <Lock className="h-6 w-6 text-indigo-600 mx-auto" />
              <div className="font-display font-black text-xl mt-2">This is a Pro section</div>
              <p className="text-sm text-zinc-500 mt-1">Unlock the full operating system to reveal.</p>
              <Link to="/#pricing" className="btn-lift inline-flex items-center gap-2 mt-4 h-10 px-5 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white text-sm">
                Unlock — from ₹999
              </Link>
            </div>
          </div>
        )}
      </div>
    </Section>
  );
}

export function LockableCard({ locked, children }) {
  return (
    <div className="relative">
      {children}
      {locked && <LockOverlay />}
    </div>
  );
}

export function LockOverlay() {
  return (
    <div className="absolute inset-0 backdrop-blur-sm bg-white/60 rounded-2xl flex items-center justify-center">
      <div className="bg-white border border-zinc-200 rounded-full px-4 py-2 shadow-sm inline-flex items-center gap-2 text-xs">
        <Lock className="h-3.5 w-3.5 text-indigo-600" /> Unlock in Pro
      </div>
    </div>
  );
}

export function LockedRow({ message }) {
  return (
    <div className="flex items-center justify-between bg-indigo-50/50 border border-dashed border-indigo-200 rounded-xl px-4 py-3 text-sm text-indigo-700">
      <div className="flex items-center gap-2"><Lock className="h-4 w-4" /> {message}</div>
      <Link to="/#pricing" className="text-xs font-medium underline decoration-dotted">Unlock →</Link>
    </div>
  );
}

export function Stat({ label, val }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-widest text-zinc-500">{label}</div>
      <div className="font-display font-black text-xl text-zinc-900 mt-1">{val}</div>
    </div>
  );
}
